import project from "./project";
import objects from "./objects";
import config from "./config";
export default {
    project,
    objects,
    config,
};